<div *ngIf="isRequestInFlight() && !bondsman" class="text-center">
    <i id="bondsman-view-spinner" class="fa fa-spinner fa-spin fa-5x text-center"></i>
</div>
<div *ngIf="errors  && !bondsman">
    <alert type="danger" *ngFor="let error of errors">{{error}}</alert>
</div>
<div *ngIf="bondsman">
<div id="bondsmanDetail" appTableOfContents appStickyHeaders class="container-fluid">
  <div id="bondsman-title" class="sticky-header-offset table-of-contents-header-offset">
  <div id="bondsman-title-text" style="font-weight:bold">
      <div *ngIf="bondsman.isLicenseeThisType(bondsman.SURETY_INSURANCE_COMPANY) === false">
          <span class="field-code ">V611</span>{{bondsman.getLicenseeLastName()}}, {{bondsman.getLicenseeFirstName()}}
        </div>
      <div *ngIf="bondsman.isLicenseeThisType(bondsman.SURETY_INSURANCE_COMPANY) === true">
          <span title="{{bondsman.getBusinessName()}}"> {{bondsman.getBusinessName()}}</span>
      </div>
    </div>
    <div id="bondsman-datetime-of-last-update"><span class="field-code">V517</span>
      <span class="search-record-last-updated-info">The displayed information was last updated from the system of record on {{searchRecordLastUpdateDate | date:'MM/dd/yyyy'}} at {{searchRecordLastUpdateDate | date:'hh:mm a'}}.</span>
    </div>
  </div>
  <div id="bondsman-main-content" class="row main-content">
    <nav id="table-of-contents-nav" [ngClass]="{'opened': tocOpen, 'closed': !tocOpen, 'opening': tocOpening}">
      <ul id="table-of-contents-nav-list" [class.table-of-contents-hidden]="!tocOpen" class="nav nav-pills nav-stacked">
        <li class="inline">
          <a id="TOC LicenseeInformation" href="#licenseeInformation">Licensee Information</a>
        </li>
        <li class="inline">
          <a id="TOC LicenseeStatus" href="#licenseeStatus">Licensee Status</a>
        </li>
        <li class="inline">
          <a id="TOC BondForfeituress" href="#bondForfeitures">Bond Forfeitures</a>
        </li>
        
         <br>
         <li *ngIf="!isProd()"><div class="show-field-code" title="{{showFieldCodeAction}}" (click)="showFieldCode()"></div></li>
      </ul>
    </nav>
    <div id="content-column" class="panel-group" [ngClass]="{'toc-opened': tocOpen, 'toc-closed': !tocOpen}">
      <div id="bondsman-view-toc-controls-outer-div" (click)="toggleTableOfContents()" [title]="tocOpen ? 'Close table of contents' : 'Open table of contents'">
        <div id="bondsman-view-toc-controls-inner-div">
          <i id="bondsman-view-toc-controls-arrow" class="fa fa-2x" [ngClass]="{'fa-chevron-circle-left': tocOpen, 'fa-chevron-circle-right': !tocOpen}"
            aria-hidden="true"></i>
        </div>
      </div>
   
      <!-- Begin Licensee-Information-->
      <div class="panel panel-default page" id="licenseeInformation">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Licensee Information</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-licensee-information [bondsman]="bondsman"></app-licensee-information>
        </div>
        <div class="title-bar">
          <h3 id="licenseeInformationTitle" class="panel-title summary-label">Licensee Information</h3>
        </div>
      </div>
      <!-- End Licensee-Information -->

      <!-- Begin Licensee-Status -->
      <div [formGroup]="countyLicenseeFormGroup">
        <div formGroupName="countyLookUp">
          <div class="panel panel-default page" id="licenseeStatus">
            <div class="panel-heading">
              <h3 class="panel-title summary-label" id="bondsman-county-select">
                Licensee Status in:&nbsp;<span class="field-code ">V638</span>
                <select [(ngModel)]="selectedCountyValue" 
                         (change)="countySelected()" 
                         style="width:200px;" 
                         id="bondsman-county-select-control" 
                         tabindex="100" 
                         formControlName="countyControl" 
                         class="input-sm">
                  <option *ngFor="let county of counties;" value="{{county.name}}">{{county.name}}</option>
                </select> County
              </h3>
            </div>
          </div>
          <div class="panel-collapse collapse in" style="height: auto;">
            <app-licensee-status [bondsman]="bondsman" [isRequestForStatusInFlight]="isRequestInFlight()"></app-licensee-status>
          </div>
          <div class="title-bar">
            <h3 id="licenseeStatusTitle" class="panel-title summary-label">Licensee Status</h3>
          </div>
        </div>
      </div>
      <!-- End Licensee-Status -->

      <!-- Begin Bond-Forfeitures -->
      <div class="panel panel-default page" id="bondForfeitures">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Bond Forfeitures</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-bond-forfeitures [bondsman]="bondsman" [isRequestForForeituresInFlight]="isRequestForForeituresInFlight()"></app-bond-forfeitures>
        </div>
        <div class="title-bar">
          <h3 id="bondForfeituresTitle" class="panel-title summary-label">Bond Forfeitures</h3>
        </div>
      </div>
      <!-- End Bond-Forfeitures -->

      <div style="height:1000px" id="extendedSpaces"></div>
    </div>
  </div>
</div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman-detail.component.html